import { Clock, Laptop, ShieldCheck, Banknote } from 'lucide-react'

const differentials = [
  {
    title: 'Atendimento Ágil',
    description:
      'Logística otimizada para evitar acúmulo de resíduos na sua unidade. Pontualidade é nosso compromisso.',
    icon: Clock,
  },
  {
    title: 'Processos Informatizados',
    description:
      'Gestão moderna com emissão digital de documentos, facilitando seu controle administrativo.',
    icon: Laptop,
  },
  {
    title: 'Conformidade Legal',
    description:
      'Geração de MTR e CDF garantida, mantendo sua empresa 100% regularizada com os órgãos ambientais.',
    icon: ShieldCheck,
  },
  {
    title: 'Preços Flexíveis',
    description:
      'Planos adaptados ao volume de geração e porte do seu estabelecimento, sem custos desnecessários.',
    icon: Banknote,
  },
]

export const Differentials = () => {
  return (
    <section id="differentials" className="py-20 bg-gray-900 text-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12">
          <div className="max-w-xl">
            <h2 className="font-heading text-3xl md:text-4xl font-bold mb-4">
              Por que escolher a Transbio?
            </h2>
            <p className="text-gray-400">
              Mais do que coletar resíduos, oferecemos tranquilidade e segurança
              para o seu negócio prosperar.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {differentials.map((item, index) => (
            <div
              key={index}
              className="bg-gray-800/50 p-6 rounded-xl border border-gray-700 hover:border-primary/50 transition-colors group"
            >
              <item.icon className="w-10 h-10 text-primary mb-4 group-hover:text-green-400 transition-colors" />
              <h3 className="font-heading text-xl font-bold mb-3">
                {item.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
